var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgBingolottIcon30 = function SvgBingolottIcon30(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M26 0v26H0V0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#003E52",
    d: "M24.375 1.625v6.5h-6.5v-6.5zm0 8.125v6.5h-6.5v-6.5zm-8.125 8.125v6.5h-6.5v-6.5zm0-16.25v6.5h-6.5v-6.5zm8.125 16.25v6.5h-6.5v-6.5zM16.25 9.75v6.5h-6.5v-6.5zM8.125 1.625v6.5h-6.5v-6.5zm0 8.125v6.5h-6.5v-6.5zm0 8.125v6.5h-6.5v-6.5z"
  }))));
};
export default SvgBingolottIcon30;